import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Icon,
  Input,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { useUpdateMeMutation } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../../common/errors/useApiError";
import { useAppDispatch } from "../../../common/redux/hooks";
import { updateMe } from "../../../common/redux/reducers/authStateReducer";

interface FormValues {
  corporateTitle: string | null;
}

export const ChangeCorporateTitle: React.FC = () => {
  const { me } = useLoggedInWithOrgContextState();
  const toast = useToast();
  const dispatch = useAppDispatch();
  const [editMe, { isLoading, error }] = useUpdateMeMutation();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { t } = useTranslation();
  const displayer = useApiError();

  const {
    formState: { errors },
    register,
    handleSubmit,
    watch,
  } = useForm<FormValues>({
    defaultValues: {
      corporateTitle: me.corporateTitle,
    },
  });

  const value = watch("corporateTitle");

  const onSubmit = async (values: FormValues) => {
    setIsRefreshing(true);

    const response = await editMe({
      editMeRequest: {
        corporateTitle: values.corporateTitle ?? undefined,
      },
    });
    if ("data" in response) {
      dispatch(updateMe(response.data));
    } else {
      displayer.trigger(response.error);
    }
    setIsRefreshing(false);

    toast({
      title: t("Corporate title has been updated!"),
      status: "success",
    });
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl mt="15px" isInvalid={errors.corporateTitle !== undefined}>
          <FormLabel htmlFor={"corporateTitle"}>{t("Corporate title")}</FormLabel>
          <Input
            id={"corporateTitle"}
            type="text"
            {...register("corporateTitle", {
              minLength: {
                value: 2,
                message: t("Must be at least 2 characters long"),
              },
            })}
          />
          <FormErrorMessage>{errors.corporateTitle && errors.corporateTitle.message}</FormErrorMessage>
          <FormHelperText>{t("Please provide your corporate title")}</FormHelperText>
        </FormControl>
        {me.corporateTitle !== value && (
          <Button
            mt="10px"
            leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
            variant={"solid"}
            colorScheme="teal"
            size={"sm"}
            isLoading={isLoading || isRefreshing}
            type="submit"
          >
            {t("Save change")}
          </Button>
        )}
      </form>
    </>
  );
};
